import React, { useState } from "react";
import axios from "axios"; // Make sure to import axios

const Subscribe = () => {
  const [formData, setFormData] = useState({
    name: "",
    avatar: "",
    attachment: null as File | null,
    description: null as string | null,
  });

  const [isSubscribed, setIsSubscribed] = useState(false);
  const [submissionStatus, setSubmissionStatus] = useState<string | null>(null);

  const handleChange: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("name", formData.name);
      formDataToSend.append("avatar", formData.avatar);
      formDataToSend.append("attachment", formData.attachment as File);
      formDataToSend.append("description", formData.description || "");

      const response = await axios.post(
        "https://localhost:7246/api/Subscribes",
        formDataToSend,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Post response:", response.data);

      // Handle success or update state accordingly
      setSubmissionStatus("Subscribed successfully!");
    } catch (error) {
      console.error("Error posting data:", error);
      // Handle error
      setSubmissionStatus("Error Subscription. Please try again.");
    }
  };

  const closePopup = () => {
    setSubmissionStatus(null);
  };

  const handleClick = () => {
    // Assuming you want to use isSubscribed in the future
    setIsSubscribed(!isSubscribed);
  };

  const buttonStyle = {
    backgroundColor: isSubscribed ? "red" : "rgba(255, 0, 0, 0.4)",
    color: "white",
  };

  return (
    <div className="flex gap-3 md:gap-6 items-center relative h-[428px]">
      <img
        src="/subscribe/Capture.PNG"
        alt="card"
        className="h-full w-full object-cover"
      />
      <div className="absolute h-full w-full flex items-center justify-center text-white">
        <div className="flex flex-col gap-5 mt-20 px-2">
          <h2 className="md:text-5xl text-2xl text-center font-bold">
            Sign Up For Our Newsletter
          </h2>
          <p className="text-center">The Next Level Journey</p>
          <form
            className="relative md:w-[650px] w-[310px] mx-auto"
            onSubmit={handleSubmit}
          >
            <input
              type="text"
              placeholder="Enter your email"
              className="shadow-xl py-3 md:py-5 pl-6 md:pl-12 pr-16 w-full -z-10 text-black"
              onChange={(e) => handleChange(e)}
              name="name" // Assuming the email field is for the 'name'
            />
            <button
              type="submit"
              className="absolute inset-y-0 right-0 flex items-center text-base md:text-lg font-semibold m-2 px-3 z-10"
              style={buttonStyle}
              onClick={handleClick}
            >
              {isSubscribed ? "Subscribed" : "Subscribe"}
            </button>
          </form>
        </div>
      </div>
      {submissionStatus && (
        <div className="absolute bottom-0 bg-gray-800 text-white p-3">
          {submissionStatus}
          <button className="ml-2" onClick={closePopup}>
            Close
          </button>
        </div>
      )}
    </div>
  );
};

export default Subscribe;
